/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRiskPoliciesForMcpServerSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskPoliciesForMcpServerSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskPoliciesForMcpServerSecurity = {
  option1?: ListRiskPoliciesForMcpServerSecurityOption1 | undefined;
  option2?: ListRiskPoliciesForMcpServerSecurityOption2 | undefined;
};

export type ListRiskPoliciesForMcpServerRequest = {
  /**
   * The MCP server ID.
   */
  mcpServerId: string;
  /**
   * Optional tool name used to apply per-server tool selections.
   */
  toolName?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskPoliciesForMcpServerSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskPoliciesForMcpServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListRiskPoliciesForMcpServerSecurityOption1$Outbound,
    ListRiskPoliciesForMcpServerSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listRiskPoliciesForMcpServerSecurityOption1ToJSON(
  listRiskPoliciesForMcpServerSecurityOption1:
    ListRiskPoliciesForMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskPoliciesForMcpServerSecurityOption1$outboundSchema.parse(
      listRiskPoliciesForMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskPoliciesForMcpServerSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskPoliciesForMcpServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListRiskPoliciesForMcpServerSecurityOption2$Outbound,
    ListRiskPoliciesForMcpServerSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listRiskPoliciesForMcpServerSecurityOption2ToJSON(
  listRiskPoliciesForMcpServerSecurityOption2:
    ListRiskPoliciesForMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskPoliciesForMcpServerSecurityOption2$outboundSchema.parse(
      listRiskPoliciesForMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskPoliciesForMcpServerSecurity$Outbound = {
  Option1?: ListRiskPoliciesForMcpServerSecurityOption1$Outbound | undefined;
  Option2?: ListRiskPoliciesForMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskPoliciesForMcpServerSecurity$outboundSchema: z.ZodMiniType<
  ListRiskPoliciesForMcpServerSecurity$Outbound,
  ListRiskPoliciesForMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskPoliciesForMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskPoliciesForMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskPoliciesForMcpServerSecurityToJSON(
  listRiskPoliciesForMcpServerSecurity: ListRiskPoliciesForMcpServerSecurity,
): string {
  return JSON.stringify(
    ListRiskPoliciesForMcpServerSecurity$outboundSchema.parse(
      listRiskPoliciesForMcpServerSecurity,
    ),
  );
}

/** @internal */
export type ListRiskPoliciesForMcpServerRequest$Outbound = {
  mcp_server_id: string;
  tool_name?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskPoliciesForMcpServerRequest$outboundSchema: z.ZodMiniType<
  ListRiskPoliciesForMcpServerRequest$Outbound,
  ListRiskPoliciesForMcpServerRequest
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    toolName: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      toolName: "tool_name",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskPoliciesForMcpServerRequestToJSON(
  listRiskPoliciesForMcpServerRequest: ListRiskPoliciesForMcpServerRequest,
): string {
  return JSON.stringify(
    ListRiskPoliciesForMcpServerRequest$outboundSchema.parse(
      listRiskPoliciesForMcpServerRequest,
    ),
  );
}
